import styled from 'styled-components';
import { Button, DeprecatedGrid as Grid, media } from '@simplywallst/ui-core';
import EditOutline from '@simplywallst/ui-core/icons/EditOutline';

export const ModalContent = styled(Grid)`
  margin-top: -12px;
`;

export const Error = styled.div`
  background: ${({ theme }) => `${theme.color.bad}`};
  border-radius: ${({ theme }) => theme.x1spacePx}px;
  padding: ${({ theme }) => `${theme.x1spacePx}px ${theme.x2spacePx}px`};
`;

export const ListContainer = styled(Grid)`
  border: ${({ theme }) => `1px solid ${theme.color.spaceGrayRGBA(0.1)}`};
  border-radius: 4px;
  padding: 12px;
`;

export const ListItem = styled('li')`
  border-top: ${({ theme }) => `1px dashed ${theme.color.spaceGrayRGBA(0.2)}`};

  padding-right: ${({ theme }) => theme.x1spacePx}px;
  padding-top: 12px;
  margin-top: 12px;
  margin-bottom: 12px;
  &:last-of-type {
    margin-bottom: 0px;
  }
`;

export const UnderlineButton = styled(Button)`
  > * {
    text-decoration: underline;
  }
`;

export const CurrencyPrefix = styled('span')`
  opacity: 0.5;
`;

export const ValuatorLink = styled(Grid)`
  cursor: pointer;
  text-decoration: none;
  padding-left: ${({ theme }) => theme.x4spacePx}px;
`;

export const UnsetFairValue = styled(Grid)`
  transform: translateY(-2px);
  ${media.smUp`
    transform: translateY(0px);
  `};
  ${media.lgUp`
    transform: translateY(-3px);
  `};
`;

export const EditIcon = styled(EditOutline)`
  fill: ${({ theme }) => theme.color.brand01};
  transform: translate(-6px, 2px);
  ${media.lgUp`
    transform: translate(-6px, 4px);
  `};
`;
